// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add styles for checkboxes */
input[type="checkbox"] {
  accent-color: var(--dunkelgruen);
}
`, "",{"version":3,"sources":["webpack://./src/arbeit/kinderverwaltung/Kinderverwaltung.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,gCAAgC;AAClC","sourcesContent":["/* Add styles for checkboxes */\ninput[type=\"checkbox\"] {\n  accent-color: var(--dunkelgruen);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
